export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8b23d4380f4e4eaab57beedfe8f2343165dd045d&name=fetchTypeahead!'